import React from "react";
import { fetchReferrals } from "../../../../actions/dropdowns.actions";
import { searchCompanies } from "../../../../actions/company.actions";
import { createEmployer } from "../../../../actions/user.actions";
import { connect } from "react-redux";
import { SubmissionError } from "redux-form";
import SignUp from "../components/SignUp";

class SignUpContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checkboxError: null
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.props.fetchReferrals();
  }

  handleSubmit(signUpData) {
    if (!signUpData.terms) {
      this.setState({
        checkboxError:
          "You must agree to our Terms of Service and Privacy Policy to continue."
      });
      throw new SubmissionError({
        terms:
          "You must agree to our Terms of Service and Privacy Policy to continue."
      });
    }

    this.setState({ checkboxError: null });

    signUpData.company_id = null;
    signUpData.company_name = null;

    if (_.get(signUpData, "company[0]")) {
      if (!_.get(signUpData, "company[0].customOption")) {
        signUpData.company_id = _.get(signUpData, "company[0].id");
      }
      signUpData.company_name = _.get(signUpData, "company[0].name") || null;
    }

    this.props.createEmployer(signUpData);
  }

  render() {
    return (
      <SignUp
        onSubmit={this.handleSubmit}
        referrals={this.props.referrals}
        companies={this.props.companies}
        isLoading={this.props.isLoading}
        onSearchCompanies={this.props.searchCompanies}
        checkboxError={this.state.checkboxError}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    referrals: state.dropdowns.referrals.data,
    companies: state.company.companies.data,
    isLoading: state.company.isLoading
  };
};

const mapDispatchToProps = dispatch => ({
  fetchReferrals: () => dispatch(fetchReferrals()),
  searchCompanies: query => dispatch(searchCompanies(query)),
  createEmployer: data => dispatch(createEmployer(data))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SignUpContainer);



// WEBPACK FOOTER //
// ./src/routes/employer/signUp/containers/SignUpContainer.js